import MessageBox from './message-box.js';

export let _Vue;

export default {
  install(Vue) {
    _Vue = Vue;
    Vue.prototype.$msgbox = MessageBox;
    Vue.prototype.$alert = MessageBox.alert;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$prompt = MessageBox.prompt;
  }
};
